module.exports = __webpack_public_path__ + "img/logo.ac5ac722.png";